












































import {Component, Prop, Vue} from "vue-property-decorator";
import {mapState} from "vuex";

declare const fbq: any;

@Component({
  components: {},
  computed: {
    ...mapState({})
  }
})
export default class ConfirmationDialog extends Vue {
  @Prop({ default: null }) private callback!: any;
  @Prop({ default: null }) private childData!: any;

  created() {
  }

  mounted() {

  }

  accept() {
    this.closeDialog();
    this.callback();
  }

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }
}
